var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"fixed-column",attrs:{"headers":_vm.localHeaders,"fixed-header":"","height":"calc(100vh - 200px)","items":_vm.items,"hide-default-footer":"","item-key":_vm.firstHeader,"disable-pagination":"","disable-sort":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }